import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {Flex, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {highlightText} from '../../../../../../../../../_legacy/library/utils/highlightText';
import styles from '../../../styles.module.scss';

type Props = {
    searchQuery: string;
    ignorecase: boolean;
    searchFromBeginning: boolean;
    searchByCategory: boolean;
    itemData: DropdownItemData;
    searchAll: boolean;
};

export const SearchContentItem = (props: Props) => {
    const {
        searchQuery,
        ignorecase,
        searchFromBeginning,
        searchByCategory,
        searchAll,
        itemData: data
    } = props;

    const description2 = (data.data as {description2: string}).description2 || '';

    if (searchByCategory) {
        return (
            <Flex componentClasses={styles.searchItem}>
                <Text
                    componentClasses={styles.searchDesc}
                    skin="paragraph-2"
                    tag="div"
                    textColor="primary-700"
                >
                    {highlightText(data.label, searchQuery, ignorecase, searchFromBeginning, true)}
                </Text>
                <Text
                    tag="div"
                    skin="paragraph-2"
                    textColor="secondary-500"
                    fontWeight="medium"
                    componentClasses={styles.value}
                >
                    {data.description}
                </Text>
            </Flex>
        );
    }

    return (
        <Flex componentClasses={styles.searchItem}>
            {Boolean(data.description || description2) && (
                <Text
                    componentClasses={styles.searchDesc}
                    skin="paragraph-2"
                    tag="div"
                    textColor="primary-700"
                >
                    {searchAll
                        ? highlightText(
                              data.description,
                              searchQuery,
                              ignorecase,
                              searchFromBeginning
                          )
                        : data.description}

                    {data.description && description2 ? (
                        <span className={styles.labelSeparator} />
                    ) : null}

                    {searchAll
                        ? highlightText(description2, searchQuery, ignorecase, searchFromBeginning)
                        : description2}
                </Text>
            )}

            <Text
                tag="div"
                skin="paragraph-2"
                textColor="secondary-500"
                fontWeight="medium"
                componentClasses={styles.value}
            >
                {searchAll
                    ? highlightText(`${data.value}`, searchQuery, ignorecase, searchFromBeginning)
                    : `${data.value}`}
            </Text>
        </Flex>
    );
};
